import styled from 'styled-components';

export const HeaderContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
  position: fixed;
  top: ${({ theme }) => theme.spacing.none};
  background: ${({ theme }) => theme.colors.darkBlue};
  z-index: 900;
`;

export const StyledSelfAssessmentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 88px ${({ theme }) => theme.spacing.m};
  row-gap: ${({ theme }) => theme.spacing.m};
`;

export const FiltersContent = styled.div`
  margin: ${({ theme }) => theme.spacing.m};
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.sm};
`;
